export class HeSocketImpl {
    constructor(url){
        this.url = url
    }
    static connectSocket(data) {
        let instance = new HeSocketImpl()
        instance.connectSocket(data)
        return instance
    }
    onOpen(cb) {
        this.scoket.addEventListener("open", cb)
    }
    onError(cb) {
        this.scoket.addEventListener("error", cb)
    }
    onMessage(cb) {
        this.scoket.addEventListener("message", (event) => {
            cb && cb(event)
        })
    }
    onClose(cb) {
        this.scoket.addEventListener("close", cb)
    }
    connectSocket(data) {
        if (this.scoket && (this.scoket.readyState !== WebSocket.CLOSED || this.scoket.readyState !== WebSocket.CLOSING)) {
            this.scoket.close()
        }
        this.scoket = null
        this.scoket = new WebSocket(data.url || this.url)
        cc.log("========= connect scoket")
    }
    close() {
        this.scoket.close()
    }
    send(data) {
        // this.scoket.send(JSON.stringify(data.data))
        this.scoket.send(data.data)
    }
}